module.exports = __webpack_public_path__ + "img/tel_1.8fedbd16.png";